import {Injectable} from '@angular/core';
import {
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireOttFormat} from '@tisa-group/models';
import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable()
export class OttFormatService {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireOttFormat[]>> {
    return this.http
      .get('/ott/formats', {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttFormat>> {
    return this.http
      .get(`/ott/formats/${fetchIdentifier}`, {
        params,
      })
      .pipe(deserialize());
  }

  delete(id: string, params?: JsonApiParams): Observable<void> {
    return this.http.delete(`/ott/formats/${id}`, {params: objectToHttpParams(params)});
  }

  create(
    body: Partial<UmpireOttFormat>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttFormat>> {
    return this.http
      .post('/ott/formats', serialize({stuff: body}), {params})
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireOttFormat>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttFormat>> {
    return this.http
      .patch(`/ott/formats/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
